import styled from "@emotion/styled";

import { theme } from "shared/lib/styles/theme";

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;

  margin-block-end: 32px;

  ${theme.breakpoints.down("desktop")} {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;
